export class EmployeeCheckRequest {
  employerId?: string;
  agentCode?: string;
  memberId?: string;
}
